module.exports = __webpack_public_path__ + "img/align-slash.141e8aa8.svg";